// Editable church content. Bracketed values are placeholders to replace with real details.
export const CHURCH = {
  name: "Victory Parañaque",
  address: "3rd Level, Bldg B, SM Sucat, Parañaque City, Metro Manila, Philippines",
  facebook: "https://www.facebook.com/VictoryParanaque/",
  email: "[church email]",
  phone: "[church phone]",
  services: [
    { day: "Sunday", time: "[Service time 1]", note: "[Venue / hall]" },
    { day: "Sunday", time: "[Service time 2]", note: "[Venue / hall]" },
    { day: "Sunday", time: "[Service time 3]", note: "[Online / in-person]" },
  ],
  ministries: [
    "[Worship ministry]", "[Kids ministry]", "[Ushering & Welcome]",
    "[Technical / Media]", "[Campus / Youth]", "[Prayer ministry]",
  ],
  welcome_new: {
    title: "You're welcome here",
    message: "Whoever you are and wherever you're coming from, there's a seat saved for you. We'd be honoured to walk with you as you discover how much God loves you.",
  },
  welcome_member: {
    title: "Welcome home, family",
    message: "It's so good to have you with us. Let's keep growing together in honoring God and making disciples.",
  },
  current_series: { title: "[Current series title]", description: "[A short description of this season's message series]" },
  past_services: [],
  slides: [
    { caption: "Honoring God.", subcaption: "Making disciples." },
    { caption: "There's a place for you.", subcaption: "Come as you are." },
    { caption: "Grow together.", subcaption: "In faith, family and purpose." },
  ],
  slide_images: [],
};

export const IMG = {
  hero: "/images/hero.jpg",
  praise: "/images/praise.jpg",
  speaker: "/images/speaker.jpg",
  group: "/images/group.jpg",
  bible: "/images/bible.jpg",
  youth: "/images/youth.jpg",
  stage: "/images/stage.jpg",
};

export const DEFAULT_SLIDE_IMAGES = [IMG.hero, IMG.praise, IMG.stage];
